import React, { useEffect, useState } from "react";
import Header from "components/Header";
import NcdKpiCards from "components/NCDKpiCards";
import { DEFAULT_BIRTHS } from 'components/BirthCards';
import ScreeningCoverage from 'components/NCDScreenCoverage';
import CaseDetectionTrends from 'components/CaseDetetaction';
import TreatmentControl from 'components/TreatmentControl';
import RiskFactorAnalysis from 'components/RiskFactorAnalysis';
import MapView from 'components/MapView';
import FacilityTable from 'components/FacilityTable';
import InsightsAlerts from 'components/InsightsAlerts';
function NCDDashboard() {
    const [districtView, setDistrictView] = useState(null);
    const [seed, setSeed] = useState(0);
    const [currentBirths, setCurrentBirths] = useState(DEFAULT_BIRTHS);
    const [stateGeoJSON, setStateGeoJSON] = useState(null);
    useEffect(() => {
        fetch(process.env.PUBLIC_URL + "/geojson/1.geojson") // state polygon
            .then((res) => res.json())
            .then((data) => setStateGeoJSON(data))
            .catch((err) => console.error("GeoJSON load error:", err));
    }, []);

    const [districtsGeoJSON, setdistrictsGeoJSON] = useState(null);
    useEffect(() => {
        fetch(process.env.PUBLIC_URL + "/geojson/1.geojson") // <- all districts
            .then((res) => res.json())
            .then((data) => setdistrictsGeoJSON(data))
            .catch((err) => console.error("GeoJSON load error:", err));
    }, []);
    const handleMenuClick = () => {
        // alert("Sidebar opened! (You can link this to real sidebar)");
    };

    const [searchQuery, setSearchQuery] = useState("");
    const [selected, setSelected] = useState("");
    return (
        <>
            <Header
                onMenuClick={handleMenuClick}
                selected={selected}
                setSelected={setSelected}
                onSearchChange={setSearchQuery}
                dashboardName="NCD Dashboard"
            />
            <div className="p-2">
                <NcdKpiCards ></NcdKpiCards>
                <div className="d-flex gap-2 mt-2">
                    <div className="col-9">
                        <ScreeningCoverage></ScreeningCoverage>
                    </div>
                    <div className="col-3">
                    <InsightsAlerts></InsightsAlerts>
                    </div>

                </div>

                <div className="row mt-1">
                    <div className="col-3">
                        <RiskFactorAnalysis></RiskFactorAnalysis>
                    </div>
                    <div className="col-9">
                        <div className="row">
                            <div className="col-6 px-2">
                                <CaseDetectionTrends></CaseDetectionTrends>
                            </div>
                            <div className="col-6 px-2">
                                <TreatmentControl></TreatmentControl>
                            </div>
                            <div className="col-8 mt-2">
                                <FacilityTable></FacilityTable>
                            </div>
                        </div>
                    </div>



                </div>
                <div className="row">
                    <div className="col-3"></div>
                    {/* <div className="col-6"> */}
                    {/* <MapView></MapView> */}
                    {/* </div> */}

                </div>


            </div>


        </>
    )
}
export default NCDDashboard;